'use strict';

var i18n = require('i18next');
var EditWebFilters = require('actions/webFilters/EditWebFilters');
var FormView = require('actions/webFilters/FormView');
var StaticView = require('actions/webFilters/StaticView');

/**
 * Action configuration for Web Filters
 */
module.exports = {
  title: i18n.t('actionWebFilters.title'),
  Model: EditWebFilters,
  FormView: FormView,
  TextView: StaticView,
};
